<section class="services-area bg-ffffff pt-100 pb-70">
    <div class="container">

        <div class="section-title text-center mb-5">
            <div class="h6 text-uppercase"><b>MIGRATE</b></div>
            <div class="h2"><span>Shopify'a Kolay ve Hızlı Geçiş</span></div>
        </div>

        <div class="row">
            <div class="col-lg-5 col-md-6 col-sm-6">
                <img src="../../../../../assets/img/migrate2a.webp" alt="migate-to-shopify" width="600" height="533"
                    class="border rounded shadow-sm">
            </div>

            <div class="col-lg-7 col-md-6 col-sm-6 pt-4">
                <div class="px-lg-5 px-md-4">
                    <div class="h4 mb-4">Verilerinizi Güvenle Aktarıyoruz</div>
                    <p>WooCommerce, OpenCart, Magento, Wix gibi popüler platformlardan veya özel yazılımlardan Shopify’a
                        veri aktarımını güvenli ve hızlı bir şekilde sağlıyoruz.
                        Entegre aracımız, tüm ürünlerinizi, siparişlerinizi ve müşteri bilgilerinizi sorunsuz bir
                        şekilde taşıyarak mağazanızın kesintisiz çalışmaya devam etmesini sağlar.
                    </p>
                    <p>Shopify’a geçiş hizmetimiz, sadece teknik bir çözüm değil, işinizi bir sonraki seviyeye taşıyacak
                        bir fırsattır. Yeni mağazanız, pazaryeri entegrasyonları,
                        ödeme sistemleri ve otomasyonlarla daha güçlü ve verimli bir şekilde çalışmaya başlar</p>
                    <p>Yeni platformunuza hızlıca geçiş yapın ve Shopify’ın sunduğu güçlü entegrasyon ve otomasyon
                        özelliklerinden faydalanın.</p>



                </div>
            </div>
        </div>
    </div>


</section>